const cooperativeIconMap = {
    // 全部 左侧（包括1、2、3、4、5）
   'defaultLeft': {
        code: 'defaultLeft',
        name: '全部',
        item_icon_: require('@/assets/images/newCooperativeIcon/btn_menu_all.png'),
        item_icon: require('@/assets/images/newCooperativeIcon/btn_menu_all_c.png'),
        bg_icon: require('@/assets/img/vehicle_icons/two/menu_bg_c.png') ,
        echartsJobFill: 'rgba(255, 153, 153, 1)',
        echartsJobLight: 'rgba(255, 153, 153, 0.3)',
        echartsLineJobLight: 'rgba(255, 153, 153, 0.6)',
        className: 'left_icon_default',
    },
    // 省级
   '1': {
        code: '1',
        name: '省级',
        item_icon_: require('@/assets/images/newCooperativeIcon/btn_menu_province.png'),
        item_icon: require('@/assets/images/newCooperativeIcon/btn_menu_province_c.png'),
        bg_icon: require('@/assets/img/vehicle_icons/two/menu_bg_c.png') ,
        echartsJobFill: 'rgba(255, 153, 153, 1)',
        echartsJobLight: 'rgba(255, 153, 153, 0.3)',
        echartsLineJobLight: 'rgba(255, 153, 153, 0.6)',
        className: 'left_icon_1',
    },
    // 市级
    '2': {
        code: '2',
        name: '市级',
        item_icon_: require('@/assets/images/newCooperativeIcon/btn_menu_prefecture.png'),
        item_icon: require('@/assets/images/newCooperativeIcon/btn_menu_prefecture_c.png'),
        bg_icon: require('@/assets/img/vehicle_icons/two/menu_bg_c.png') ,
        echartsJobFill: 'rgba(255, 153, 153, 1)',
        echartsJobLight: 'rgba(255, 153, 153, 0.3)',
        echartsLineJobLight: 'rgba(255, 153, 153, 0.6)',
        className: 'left_icon_2',
    },
    // 县区
   '3': {
        code: '3',
        name: '县区级',
        item_icon_: require('@/assets/images/newCooperativeIcon/btn_menu_county.png'),
        item_icon: require('@/assets/images/newCooperativeIcon/btn_menu_county_c.png'),
        bg_icon: require('@/assets/img/vehicle_icons/two/menu_bg_c.png') ,
        echartsJobFill: 'rgba(255, 153, 153, 1)',
        echartsJobLight: 'rgba(255, 153, 153, 0.3)',
        echartsLineJobLight: 'rgba(255, 153, 153, 0.6)',
        className: 'left_icon_3',
    },
    // 一般认证合作社
    '4': {
        code: '4',
        name: '一般认证合作社',
        item_icon_: require('@/assets/images/newCooperativeIcon/btn_menu_certified.png'),
        item_icon: require('@/assets/images/newCooperativeIcon/btn_menu_certified_c.png'),
        bg_icon: require('@/assets/img/vehicle_icons/two/menu_bg_c.png') ,
        echartsJobFill: 'rgba(255, 153, 153, 1)',
        echartsJobLight: 'rgba(255, 153, 153, 0.3)',
        echartsLineJobLight: 'rgba(255, 153, 153, 0.6)',
        className: 'left_icon_4',
    },
    // 一般未认证合作社
   '5': {
        code: '5',
        name: '一般未认证合作社',
        item_icon_: require('@/assets/images/newCooperativeIcon/btn_menu_uncertified.png'),
        item_icon: require('@/assets/images/newCooperativeIcon/btn_menu_uncertified_c.png'),
        bg_icon: require('@/assets/img/vehicle_icons/two/menu_bg_c.png') ,
        echartsJobFill: 'rgba(255, 153, 153, 1)',
        echartsJobLight: 'rgba(255, 153, 153, 0.3)',
        echartsLineJobLight: 'rgba(255, 153, 153, 0.6)',
        className: 'left_icon_5',
    },
    // 全部 全部 右侧（包括6、7、8、9、10、11）
    'defaultRight': {
        code: 'defaultRight',
        name: '全部',
        item_icon_: require('@/assets/images/newCooperativeIcon/btn_menu_allt.png'),
        item_icon: require('@/assets/images/newCooperativeIcon/btn_menu_allt_c.png'),
        bg_icon: require('@/assets/img/vehicle_icons/two/menu_bg_c.png') ,
        echartsJobFill: 'rgba(255, 153, 153, 1)',
        echartsJobLight: 'rgba(255, 153, 153, 0.3)',
        echartsLineJobLight: 'rgba(255, 153, 153, 0.6)',
        className: 'bottom_icon_default',
    },
    // 应急
   '6': {
        code: '6',
        name: '应急服务队',
        item_icon_: require('@/assets/images/newCooperativeIcon/btn_menu_yj.png'),
        item_icon: require('@/assets/images/newCooperativeIcon/btn_menu_yj_c.png'),
        bg_icon: require('@/assets/img/vehicle_icons/two/menu_bg_c.png'),
        echartsJobFill: 'rgba(255, 153, 153, 1)',
        echartsJobLight: 'rgba(255, 153, 153, 0.3)',
        echartsLineJobLight: 'rgba(255, 153, 153, 0.6)',
        className: 'bottom_icon_6',
    },
    // 烘干
    '7': {
        code: '7',
        name: '烘干中心',
        item_icon_: require('@/assets/images/newCooperativeIcon/btn_menu_hgt.png'),
        item_icon: require('@/assets/images/newCooperativeIcon/btn_menu_hgt_c.png'),
        bg_icon: require('@/assets/img/vehicle_icons/two/menu_bg_c.png') ,
        echartsJobFill: 'rgba(255, 153, 153, 1)',
        echartsJobLight: 'rgba(255, 153, 153, 0.3)',
        echartsLineJobLight: 'rgba(255, 153, 153, 0.6)',
        className: 'bottom_icon_7',
    },
    // 收割机大户
   '8': {
        code: '8',
        name: '收割机大户',
        item_icon_: require('@/assets/images/newCooperativeIcon/btn_menu_shjdh.png'),
        item_icon: require('@/assets/images/newCooperativeIcon/btn_menu_shjdh_c.png'),
        bg_icon: require('@/assets/img/vehicle_icons/two/menu_bg_c.png') ,
        echartsJobFill: 'rgba(255, 153, 153, 1)',
        echartsJobLight: 'rgba(255, 153, 153, 0.3)',
        echartsLineJobLight: 'rgba(255, 153, 153, 0.6)',
        className: 'bottom_icon_8',
    },
    // 拖拉机大户
   '9': {
        code: '9',
        name: '拖拉机大户',
        item_icon_: require('@/assets/images/newCooperativeIcon/btn_menu_tljdh.png'),
        item_icon: require('@/assets/images/newCooperativeIcon/btn_menu_tljdh_c.png'),
        bg_icon: require('@/assets/img/vehicle_icons/two/menu_bg_c.png') ,
        echartsJobFill: 'rgba(255, 153, 153, 1)',
        echartsJobLight: 'rgba(255, 153, 153, 0.3)',
        echartsLineJobLight: 'rgba(255, 153, 153, 0.6)',
        className: 'bottom_icon_9',
    },
    // 种地大户
    '10': {
        code: '10',
        name: '种地大户',
        item_icon_: require('@/assets/images/newCooperativeIcon/btn_menu_zddh.png'),
        item_icon: require('@/assets/images/newCooperativeIcon/btn_menu_zddh_c.png'),
        bg_icon: require('@/assets/img/vehicle_icons/two/menu_bg_c.png') ,
        echartsJobFill: 'rgba(255, 153, 153, 1)',
        echartsJobLight: 'rgba(255, 153, 153, 0.3)',
        echartsLineJobLight: 'rgba(255, 153, 153, 0.6)',
        className: 'bottom_icon_10',
    },
    
}
export default cooperativeIconMap